
<div class="sg-login-spinner">
    <!-- <span class="sg-login-message"><h5>Completing Login...</h5></span> -->
    <mat-spinner ></mat-spinner>
</div> 